/** Root of every user query; one invalidation refreshes lists, pickers and details. */
export const USERS_QUERY_ROOT = ['core', 'users'] as const;

/** Query key of one user's detail. */
export const userDetailKey = (uuid: string) => [...USERS_QUERY_ROOT, 'detail', uuid] as const;

/** The signed-in user's own email verification status. */
export const EMAIL_VERIFICATION_QUERY_KEY = [...USERS_QUERY_ROOT, 'emailVerification'] as const;
